/**
 * useCurrency — the single hook every price-rendering component uses.
 *
 * The store is USD-based: every stored cent is a USD cent, and every order is
 * charged in USD. This hook formats those cents for display.
 *
 *   const { fmt } = useCurrency();
 *
 * It intentionally keeps a stable return shape (currency/fmt/setCurrency/…) so
 * existing call sites keep working, including the admin back office that calls
 * useCurrency({ usd: true }). There is no longer a display-currency toggle —
 * everything is USD.
 */
import { formatPrice } from '../utils/helpers';

export function useCurrency() {
  return {
    currency: 'USD',
    effectiveCurrency: 'USD',
    rate: null,
    fxFetchedAt: null,
    fmt: (cents) => formatPrice(cents),
    setCurrency: () => {},
    toggleCurrency: () => {},
  };
}
